// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1Fzzi","inputWrap":"CustomTip_inputWrap__8t902"};